import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "payment-select-option__info" }
const _hoisted_2 = { class: "payment-select-option__name" }
const _hoisted_3 = { key: 0 }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { type ModalVariant } from '@exchange/libs/modals/src';
import { type FundingProviderModel } from '@exchange/libs/transactions/funds/service/src';
import { type CurrencyModel } from '@exchange/libs/utils/currency/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSelectOption',
  props: {
  blockchainFee: { type: String, required: true },
  currency: { type: Object as PropType<CurrencyModel>, required: true },
  currencyNetwork: { type: String, required: false },
  isBlockchain: { type: Boolean, default: false },
  isInstant: { type: Boolean, default: false },
  isListItem: { type: Boolean, default: false },
  paymentOption: { type: Object as PropType<FundingProviderModel>, required: true },
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const name = computed(() => t(`modules.funds.api.transferMethods.${props.paymentOption.title}`));
const daysToTransfer = computed(() => (props.isBlockchain ? undefined : t(`modules.transactions.paymentOptions.${props.isInstant ? 'instant' : 'notInstant'}`)));
const nameToDisplay = computed(() => {
  const days = daysToTransfer.value ? `(${daysToTransfer.value})` : '';

  return `${name.value} ${days}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["payment-select-option", [`payment-select-option--${__props.variant}`, { 'payment-select-option--list-item': __props.isListItem }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(nameToDisplay.value), 1)
    ]),
    (__props.isBlockchain && __props.currencyNetwork)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.currencyNetwork), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})